import { Helmet } from "react-helmet-async"
import { cn } from "./ui/lib/utils"

type TPageTitleProps = {
  title: string
  className?: string
}

export const PageTitle = ({ title, className = "" }: TPageTitleProps) => {
  return (
    <>
      <Helmet title={title} />
      <h1 className={cn("tw:text-3xl tw:font-bold", className)}>{title}</h1>
    </>
  )
}
